import { getNextValidBreakdowns, ProductVariantBreakdownTypes } from './utils';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useQuoteSheetTableContext } from './quotes-sheet-table.context';
import React from 'react';

const breakdownLabels: Record<ProductVariantBreakdownTypes, string> = {
  [ProductVariantBreakdownTypes.PRODUCT]: 'Product',
  [ProductVariantBreakdownTypes.ENUMERATED_VARIANT]: 'Variant',
  // [ProductVariantBreakdownTypes.RECURSIVE_VARIANT]: 'Variants With Subsets',
  [ProductVariantBreakdownTypes.SUPPLIER]: 'Supplier',
};

function BreakdownSelect({
  productVariantBreakdownPrev,
  selectedBreakdown,
  onSelectBreakdown,
}: {
  productVariantBreakdownPrev?: ProductVariantBreakdownTypes[];
  selectedBreakdown?: ProductVariantBreakdownTypes;
  onSelectBreakdown: (breakdown: ProductVariantBreakdownTypes[]) => void;
}) {
  const validBreakdownsAtLevel = getNextValidBreakdowns(
    productVariantBreakdownPrev ?? [],
  );

  return (
    <Select
      value={selectedBreakdown}
      onValueChange={(value) => {
        onSelectBreakdown([
          ...(productVariantBreakdownPrev ?? []),
          value as ProductVariantBreakdownTypes,
        ]);
      }}
    >
      <SelectTrigger>
        <SelectValue
          placeholder={
            selectedBreakdown
              ? breakdownLabels[selectedBreakdown]
              : 'Select a breakdown'
          }
        />
      </SelectTrigger>
      <SelectContent>
        {validBreakdownsAtLevel.map((breakdown) => (
          <SelectItem key={breakdown} value={breakdown}>
            {breakdownLabels[breakdown]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
export function ProductVariantBreakdown() {
  const {
    productVariantBreakdown,
    implicitRestOfBreakdown,
    onSelectBreakdown,
  } = useQuoteSheetTableContext();

  return (
    <div className="flex flex-row gap-0.5 pb-1">
      {productVariantBreakdown.map((breakdown, index) => (
        <React.Fragment key={breakdown}>
          <BreakdownSelect
            selectedBreakdown={breakdown}
            productVariantBreakdownPrev={productVariantBreakdown.slice(
              0,
              index,
            )}
            onSelectBreakdown={onSelectBreakdown}
          />
          {(index < productVariantBreakdown.length - 1 ||
            implicitRestOfBreakdown.length > 0) && (
            <span className="text-muted-foreground text-sm self-center px-1">
              then
            </span>
          )}
        </React.Fragment>
      ))}
      {implicitRestOfBreakdown.map((breakdown, index) => (
        <React.Fragment key={breakdown}>
          <BreakdownSelect
            selectedBreakdown={breakdown}
            productVariantBreakdownPrev={[
              ...productVariantBreakdown,
              ...implicitRestOfBreakdown,
            ].slice(0, productVariantBreakdown.length + index)}
            onSelectBreakdown={onSelectBreakdown}
          />
          {index < implicitRestOfBreakdown.length - 1 && (
            <span className="text-muted-foreground text-sm self-center px-1">
              then
            </span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
